import React from "react";
import Help from "./help";
import Code from "./json";
import Table from "./table";
import MetaTable from "./metadata_table";
import HotspotSelector from "./hotspotSelector"

export default props => {
  // console.log(props)
  switch (props.mode) {
    case "code":
      return <Code
        {...props}
      />
    case "metaTable":
      return <MetaTable
        {...props}
      />
    case "HotspotSelector":
      return <HotspotSelector {...props} />
    case "table":
      return <Table {...props} />
    default:
      return <Help />
  }
};
